module.exports = __webpack_public_path__ + "media/images/area/feature/chugoku/related/vi/1-72a60b5af29ea8c9932e6130410a69a7.jpg";